<mat-toolbar color="primary">
  <a class="header-brand-link" routerLink="/map" aria-label="Brand Logo" (click)="setHeaderState(false)">
    <span class="header-brand-name"> Fresh-Tap </span>
  </a>
  <div class="spacer"></div>
  <mat-select
    [value]="unitConversionService.CurrentUnit"
    (selectionChange)="onUnitChanged($event)"
  >
    <mat-option value="km"> km </mat-option>
    <mat-option value="mi"> mi </mat-option>
  </mat-select>

  <button mat-icon-button (click)="toggleHeader()">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="header-nav-menu" [class.is-opened]="isOpen">
    <mat-nav-list>
      <mat-list-item (click)="toggleHeader()">
        <a matLine routerLink="/map">Map</a>
      </mat-list-item>
      <mat-list-item (click)="toggleHeader()">
        <a matLine routerLink="/about">About</a>
      </mat-list-item>
    </mat-nav-list>
    <div class="spacer"></div>
    <mat-nav-list>
      <mat-list-item (click)="toggleHeader()">
        <a matLine routerLink="/imprint">Imprint</a>
      </mat-list-item>
      <mat-list-item (click)="toggleHeader()">
        <a matLine routerLink="/data-privacy">Data Privacy</a>
      </mat-list-item>
      <mat-list-item (click)="toggleHeader()">
        <a matLine routerLink="/disclaimer">Disclaimer</a>
      </mat-list-item>
    </mat-nav-list>
  </div>

  <!-- 
  
  
    <mat-select
      [value]="unitConversionService.CurrentUnit"
      (selectionChange)="onUnitChanged($event)"
    >
      <mat-option value="km"> km </mat-option>
      <mat-option value="mi"> mi </mat-option>
    </mat-select>
    -->
</mat-toolbar>
